
export const fetchWithFallback = async (url, options = {}) => {
  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
    return response;
  } catch (error) {
    console.error('API fetch error:', error);
    throw error;
  }
};

/**
 * Mock job offers data (fallback when API fails)
 */
export const mockJobOffers = [
  {
    id: 1,
    title: 'Pracownik produkcji',
    location: 'Niemcy, Frankfurt',
    description: 'Praca w zakładzie produkcyjnym. Doświadczenie nie jest wymagane.',
    alldescription: 'Poszukujemy pracowników do pracy w zakładzie produkcyjnym w Niemczech. Oferujemy konkurencyjne wynagrodzenie, zakwaterowanie oraz transport.',
    image: 'job1.jpg',
    salary: '2500-3000 EUR/miesiąc',
    employment_type: 'Pełny etat',
    is_top: true,
    featured: true,
    is_user_added: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 2,
    title: 'Operator wózka widłowego',
    location: 'Holandia, Rotterdam',
    description: 'Praca w magazynie logistycznym. Wymagane uprawnienia UDT.',
    alldescription: 'Poszukujemy operatorów wózków widłowych z aktualnymi uprawnieniami UDT. Praca w nowoczesnym magazynie logistycznym.',
    image: 'job2.jpg',
    salary: '2800-3200 EUR/miesiąc',
    employment_type: 'Pełny etat',
    is_top: false,
    featured: false,
    is_user_added: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 3,
    title: 'Pracownik budowlany',
    location: 'Niemcy, Berlin',
    description: 'Praca na budowie. Doświadczenie w budownictwie będzie atutem.',
    alldescription: 'Zatrudnimy pracowników budowlanych do pracy przy różnych projektach budowlanych w Berlinie. Zapewniamy zakwaterowanie i transport.',
    image: 'job3.jpg',
    salary: '2600-3100 EUR/miesiąc',
    employment_type: 'Pełny etat',
    is_top: true,
    featured: true,
    is_user_added: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
];

/**
 * Mock news articles data (fallback when API fails)
 */
export const mockNews = [
  {
    id: 1,
    title: 'Nowe możliwości pracy w Niemczech',
    excerpt: 'Otworzyliśmy nowe możliwości zatrudnienia w sektorze produkcyjnym w Niemczech.',
    content: '<p>Otworzyliśmy nowe możliwości zatrudnienia w sektorze produkcyjnym w Niemczech. Oferujemy konkurencyjne warunki pracy oraz pełne wsparcie w procesie rekrutacji.</p>',
    image: 'news1.jpg',
    is_featured: true,
    featured: true,
    is_published: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 2,
    title: 'Sukces naszych pracowników',
    excerpt: 'Poznaj historie sukcesu naszych pracowników, którzy znaleźli wymarzną pracę za granicą.',
    content: '<p>Poznaj historie sukcesu naszych pracowników, którzy znaleźli wymarzną pracę za granicą dzięki OpusA.P.T.</p>',
    image: 'news2.jpg',
    is_featured: false,
    featured: false,
    is_published: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 3,
    title: 'Nowe biuro w Warszawie',
    excerpt: 'Otworzyliśmy nowe biuro w centrum Warszawy, aby lepiej służyć naszym klientom.',
    content: '<p>Z przyjemnością informujemy o otwarciu naszego nowego biura w centrum Warszawy. Zapraszamy do odwiedzin!</p>',
    image: 'news3.jpg',
    is_featured: true,
    featured: true,
    is_published: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
];

/**
 * Mock gallery data (fallback when API fails)
 */
export const mockGallery = [
  {
    id: 1,
    image: '/api/placeholder/800/600',
    caption: 'Komfortowy pokój mieszkalny',
    alt_text: 'Przestronna sypialnia z wygodnymi łóżkami',
    description: 'Przestronna sypialnia z wygodnymi łóżkami',
    type: 'accommodation',
    is_active: true,
    display_order: 1,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 2,
    image: '/api/placeholder/800/600',
    caption: 'Nowoczesna kuchnia',
    alt_text: 'W pełni wyposażona kuchnia',
    description: 'W pełni wyposażona kuchnia',
    type: 'accommodation',
    is_active: true,
    display_order: 2,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 3,
    image: '/api/placeholder/800/600',
    caption: 'Czysta łazienka',
    alt_text: 'Nowoczesna łazienka z prysznicem',
    description: 'Nowoczesna łazienka z prysznicem',
    type: 'accommodation',
    is_active: true,
    display_order: 3,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 4,
    image: '/api/placeholder/800/600',
    caption: 'Wspólna przestrzeń',
    alt_text: 'Przytulny salon dla mieszkańców',
    description: 'Przytulny salon dla mieszkańców',
    type: 'accommodation',
    is_active: true,
    display_order: 4,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 5,
    image: '/api/placeholder/800/600',
    caption: 'Widok z zewnątrz',
    alt_text: 'Budynek mieszkalny z zewnątrz',
    description: 'Budynek mieszkalny z zewnątrz',
    type: 'accommodation',
    is_active: true,
    display_order: 5,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
];

/**
 * Get API base URL from environment variable
 */
export const getApiBaseUrl = () => {
  return process.env.REACT_APP_API_URL;
};

/**
 * Get uploads base URL for images (derived from API URL)
 */
export const getUploadsBaseUrl = () => {
  return process.env.REACT_APP_API_URL?.replace('/api', '/uploads');
};
